import { endpoints } from '../api/apiCommons'

const bffBase = () =>
  (process.env.REACT_APP_BFF || '').trim().replace(/\/+$/, '')

const toRespuestas = (answers) =>
  Object.entries(answers).flatMap(([codigoPregunta, value]) => {
    if (
      value == null ||
      value === '' ||
      (Array.isArray(value) && !value.length)
    )
      return []

    if (typeof value === 'object' && !Array.isArray(value)) {
      const opcion = value.ValorOpcion ?? null
      const texto = String(value.ValorTexto ?? value.text ?? '').trim()
      if (!opcion && !texto) return []
      return [
        {
          CodigoPregunta: String(codigoPregunta),
          ValorOpcion: opcion,
          ValorTexto: texto || null,
        },
      ]
    }

    if (Array.isArray(value)) {
      return value.map((valor) => ({
        CodigoPregunta: String(codigoPregunta),
        ValorOpcion: String(valor),
      }))
    }

    return [
      { CodigoPregunta: String(codigoPregunta), ValorOpcion: String(value) },
    ]
  })

export const submitSurveyAnswers = async ({
  companyId,
  surveyCode,
  answers,
}) => {
  const payload = {
    SEmpresa: String(companyId ?? ''),
    CodigoSurvey: surveyCode,
    Usuario: String(companyId ?? ''),
    Portal: 'verde',
    Respuestas: toRespuestas(answers),
  }

  const path = endpoints?.surveyRegistrar || 'Survey/Registrar'
  const response = await fetch(`${bffBase()}/${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('token') || '',
    },
    body: JSON.stringify(payload),
  })

  if (!response.ok) {
    const message = await response.text().catch(() => '')
    throw new Error(`HTTP ${response.status} ${message}`)
  }
  const body = await response.json().catch(() => null)
  const result = body?.data?.data ?? body?.data ?? body
  if (result?.Exito === false || result?.exito === false) {
    throw new Error(result?.Mensaje || result?.mensaje || 'El servidor no confirmó la encuesta')
  }
  return result
}
